import { render } from "./PaymentInfo.vue?vue&type=template&id=21623f4c"
import script from "./PaymentInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentInfo.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/PaymentInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21623f4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21623f4c', __exports__)) {
    api.reload('21623f4c', __exports__)
  }
  
  module.hot.accept("./PaymentInfo.vue?vue&type=template&id=21623f4c", () => {
    api.rerender('21623f4c', render)
  })

}


export default __exports__